import React, { useState } from "react";
import "./DESetup.scss";
import NewUserSignupES from "./SignUp/FormsES";
import Modal from "../../ReuseableComponents/Modal/Modal";
import { useNavigate } from "react-router-dom";
import { MdEdit } from "react-icons/md";
import Loader from "../../ReuseableComponents/Loader/Loader";
import HeroTextEs from "./Text/HeroTextES";
import HeroTitleES from "./Text/HeroTitleES";
import HeroContactES from "./Text/HeroContactES";
export interface StaffProps {
  webTemplate: any;
  loading: any;
  setLoading: any;
  isStaff: any;
}

const HeroSectionES = ({
  webTemplate,
  loading,
  setLoading,
  isStaff,
}: StaffProps) => {
  let token = localStorage.getItem("token");
  const [showModal, setShowModal] = useState(false);
  const [showTextModal, setShowTextModal] = useState(false);
  const [note, setNote] = useState<any>();
  const [showTitleModal, setShowTitleModal] = useState(false);
  const [title, setTitle] = useState<any>();
  const [showContactModal, setShowContactModal] = useState(false);
  const [contact, setContact] = useState<any>();

  let loginLink = "/search-documents";

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/search-documents");
  };
  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenTextModal = () => {
    setShowTextModal(true);
    setNote(webTemplate?.hero_section_body_es);
  };

  const handleCloseTextModal = () => {
    setShowTextModal(false);
  };

  const handleOpenTitleModal = () => {
    setShowTitleModal(true);
    setTitle(webTemplate?.hero_section_title_es);
  };

  const handleCloseTitleModal = () => {
    setShowTitleModal(false);
  };

  const handleOpenContactModal = () => {
    setShowContactModal(true);
    setContact(webTemplate?.hero_section_contact_es);
  };

  const handleCloseContactModal = () => {
    setShowContactModal(false);
  };
  return (
    <div className="hero-page">
      <div className="hero-container">
        <div className="hero-content">
          <div className="top-headings"> 
            {loading ? (
              <div className="heading-loader">
                <Loader width={330} />
                <h4
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "16px",
                    margin: 0,
                  }}
                >
                  Buscando Título
                </h4>
              </div>
            ) : (
              <h1 className="title">
                {webTemplate?.hero_section_title_es}{" "}
                <MdEdit
                  style={{ display: isStaff ? "inline-block" : "none" }}
                  className="edit-icon"
                  onClick={handleOpenTitleModal}
                />
              </h1>
            )}
            {loading ? (
              <div className="heading-loader">
                <Loader width={330} />
                <h4
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "16px",
                    margin: 0,
                  }}
                >
                  Buscando Contacto
                </h4>
              </div>
            ) : (
              <h1 className="email-link">
                {webTemplate?.hero_section_contact_es}{" "}
                <MdEdit
                  style={{ display: isStaff ? "inline-block" : "none" }}
                  className="edit-icon"
                  onClick={handleOpenContactModal}
                />
              </h1>
            )}
          </div>
          <div
            className="hero-button"
            onClick={handleNavigate}
            // style={{ display: token ? "flex" : "none" }}
          >
            Buscar Documentos
          </div>
          {/* <div
            className="hero-button"
            onClick={handleOpenModal}
            style={{ display: token ? "none" : "flex" }}
          >
            Buscar Documentos
          </div> */}
          <div className="note">
            {loading ? (
              <>
                <Loader width={330} />
                <h4
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "16px",
                    margin: 0,
                  }}
                >
                  Buscando Nota
                </h4>
              </>
            ) : (
              <h6>
                {webTemplate?.hero_section_body_es}{" "}
                <MdEdit
                  style={{ display: isStaff ? "inline-block" : "none" }}
                  className="edit-icon"
                  onClick={handleOpenTextModal}
                />
              </h6>
            )}
          </div>

          <div className="col-md-3">
            {showModal && (
              <Modal
                title="Leyes de Puerto Rico"
                content={
                  <NewUserSignupES
                    handleCloseModal={handleCloseModal}
                    loginLink={loginLink}
                  />
                }
                onClose={handleCloseModal}
              />
            )}
          </div>
          <div className="col-md-3">
            {showTextModal && (
              <Modal
                title="Nota de Actualización"
                content={
                  <HeroTextEs
                    note={note}
                    setNote={setNote}
                    handleCloseTextModal={handleCloseTextModal}
                    loading={loading}
                    setLoading={setLoading}
                  />
                }
                onClose={handleCloseTextModal}
              />
            )}
          </div>

          <div className="col-md-3">
            {showTitleModal && (
              <Modal
                title="Actualizar Título"
                content={
                  <HeroTitleES
                    title={title}
                    setTitle={setTitle}
                    handleCloseTitleModal={handleCloseTitleModal}
                    loading={loading}
                    setLoading={setLoading}
                  />
                }
                onClose={handleCloseTitleModal}
              />
            )}
          </div>

          <div className="col-md-3">
            {showContactModal && (
              <Modal
                title="Actualizar Contacto"
                content={
                  <HeroContactES
                    contact={contact}
                    setContact={setContact}
                    handleCloseContactModal={handleCloseContactModal}
                    loading={loading}
                    setLoading={setLoading}
                  />
                }
                onClose={handleCloseContactModal}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSectionES;
